//ICONS

export const ARROW_RIGHT = '/img/icons/arrow-right-short.svg#icon';
export const ARROW_BUTTON = '/img/icons/arrow-right-up.svg#icon';
export const ARROW_BUTTON_HOVER = '/img/icons/arrow-right-up-hover.svg#icon';
export const ARROW_DOWN_UP = '/img/icons/arrow-down-up.svg#icon';

export const CHECK = '/img/icons/check2.svg#icon';

export const SEARCH = '/img/icons/search.svg#icon';
export const COPY = '/img/icons/copy.svg#icon';

export const CLOSE = '/img/icons/x.svg#icon';
export const CHEVRON_DOWN = '/img/icons/chevron-down.svg#icon';
export const REPEAT = '/img/icons/repeat.svg#icon';
export const EYE_SHOW = '/img/icons/eye-fill.svg#icon';
export const EYE_HIDE = '/img/icons/eye-slash-fill.svg#icon';
export const QUESTION = '/img/icons/question-circle.svg#icon';
export const SHARE = '/img/icons/share-fill.svg#icon';

export const ERROR = '/img/icons/error.png';
export const STAR = '/img/icons/star.png';
export const STAROFF = '/img/icons/starOff.png';

export const COPY2 = '/img/icons/copy.png';

export const PORTFOLIO = '/img/icons/portfolio.png';
export const DISCONNECT = '/img/icons/disconnect.png';

//TOKENS

export const TOKEN_ICON_ADA = '/img/tokens/ada.png';
export const TOKEN_ICON_ADA_DARK = '/img/tokens/ada-dark.png';

export const TOKEN_COLOR_ADA = '#2352B4';

//WALETS

export const WALLET_ETERNL_ICON = '/img/wallet/eternl.png';
export const WALLET_NAMI_ICON = '/img/wallet/nami.png';
export const WALLET_FLINT_ICON = '/img/wallet/flint.png';
export const WALLET_TYPHON_ICON = '/img/wallet/typhon.png';
export const WALLET_NUFI_ICON = '/img/wallet/nufi.png';
export const WALLET_YOROI_ICON = '/img/wallet/yoroi.png';
export const WALLET_LACE_ICON = '/img/wallet/lace.png';
export const WALLET_VESPR_ICON = '/img/wallet/vespr.png';
